import React from 'react';
import { Section } from './Section';
import { Shield, Award, HeadphonesIcon, CreditCard } from 'lucide-react';
const trustItems = [{
  icon: Shield,
  title: 'Compra segura',
  detail: 'Pago 100% protegido'
}, {
  icon: Award,
  title: 'Garantía 7 días',
  detail: 'Soporte directo'
}, {
  icon: HeadphonesIcon,
  title: 'Atención personalizada',
  detail: 'WhatsApp y email'
}, {
  icon: CreditCard,
  title: 'Medios de pago',
  detail: 'Tarjetas y transferencia'
}];
export function Trust() {
  return <Section className="py-16 md:py-20 border-t border-black/5" data-id="element-184">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-185">
        {trustItems.map((item, i) => <div key={i} className="flex flex-col items-center text-center gap-3" data-id="element-186">
            <div className="w-12 h-12 rounded-xl bg-[#FF6B1A]/10 flex items-center justify-center text-[#FF6B1A]" data-id="element-187">
              <item.icon strokeWidth={1.5} size={22} data-id="element-188" />
            </div>
            <div data-id="element-189">
              <div className="text-sm font-semibold text-[#0A0A0A]" data-id="element-190">
                {item.title}
              </div>
              <div className="text-xs text-[#6B6B6B] font-light mt-1" data-id="element-191">
                {item.detail}
              </div>
            </div>
          </div>)}
      </div>
    </Section>;
}